import styled from 'styled-components';

export const StyledTableContainer = styled.div``;
